import React from 'react'
import { Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import SelectStationComponent from '../../../../components/modal/SelectStationComponent'
import RadioButtons from '../../../../components/forms/RadioButtons'
import NumberField from '../../../../components/forms/NumberField'
import Input from '../../../../components/forms/Input'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import { hasBooleanValue } from '../../../../utils/NumberUtil'
import { groupBy, orderBy } from 'lodash'
import ReactEchartsCore from 'echarts-for-react/lib/core'
import echarts from 'echarts/lib/echarts'
import Checkbox from '../../../../components/forms/Checkbox'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import StepperDialog from 'components/modal/StepperDialog'
import { ButtonMUI } from 'components/styled/Buttons'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import Select from '../../../../components/forms/Select'
import { getMapSituationRefUsedList } from './FrequencyStatDialog'
import { getCalculTypeOptions } from '../MapSituationUtils'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'

const STEP = {
    STATIONS: 0,
    CALCULATE: 1,
}

const getThresholdIndicatorPie = (results) => {
    if (results.length) {
        const group = groupBy(results, 'trendColor')
        const chartData = Object.keys(group).map(key => {
            return {
                value: group[key].length,
                name: key === 'undefined' ? 'Pas de classe' : group[key][0].thresholdName,
                color: key === 'undefined' ? 'gray' : group[key][0].trendColor,
            }
        })

        const options = {
            color: chartData.map(o => o.color),
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c} ({d}%)',
            },
            series: [
                {
                    type: 'pie',
                    data: chartData,
                    avoidLabelOverlap: false,
                    radius: ['50%', '70%'],
                    label: {
                        normal: {
                            show: false,
                            position: 'center',
                        },
                    },
                    labelLine: {
                        normal: {
                            show: false,
                        },
                    },
                },
            ],
        }

        return (
            <ReactEchartsCore
                echarts={ echarts }
                option={ options }
                notMerge={ true }
                lazyUpdate={ true }
                className={ 'row no-margin' }
                style={ { height: 200 } }
            />
        )
    }
    return null
}

const getThresholdIndicatorLegend = () => {
    return (
        <Grid container sx={{ paddingLeft: 1 }}>
            <Grid size={12}>
                <ul>
                    <li><img style={{ marginBottom: '-5px' }} src={'pictures/indicators/map_arrow_up_gray.png'} className='max-width-20 margin-right-1 responsive-img'/>{ i18n.improvement }</li>
                    <li><img style={{ marginBottom: '-5px' }} src={'pictures/indicators/map_arrow_right_gray.png'} className='max-width-20 margin-right-1 responsive-img'/>{ i18n.stagnation }</li>
                    <li><img style={{ marginBottom: '-5px' }} src={'pictures/indicators/map_arrow_down_gray.png'} className='max-width-20 margin-right-1 responsive-img'/>{ i18n.degradation }</li>
                </ul>
            </Grid>
        </Grid>
    )
}

const getThresholdIndicatorDefaultParams = () => ({
    allStations: true,
    stationIds: [],
    stats: [],
    validOnly: false,
    nbYearsHistoRequired: 1,
    nbDaysWithoutMeasuresMax: 7,
    fluctuationPercentage: 0.10,
    nbDaysForTrendCalculation: 7,
    nbHoursCumul: 24,
})

const AVERAGE= 'AVERAGE'
const MEDIAN= 'MEDIAN'
const MIN = 'MIN'
const MAX = 'MAX'
const OTHER = 'OTHER'

const getThresholdIndicatorDialog = (state, changeState, onSave, stations, dataTypes, st, contributors = []) => {
    const { msSelected, paramsDialogIsOpen } = state
    const isPluviometry = st === STATION_TYPE_NAME.pluviometry

    const params = JSON.parse(msSelected.params)

    const change = changes => changeState({ msSelected: { ...msSelected, ...changes } })

    const changeParams = (changes) => {
        changeState({ msSelected: { ...msSelected, params: JSON.stringify({ ...params, ...changes }) } })
    }

    const refList = getMapSituationRefUsedList(st)

    const calculMethodOptions = [
        { code: AVERAGE, name: i18n.average },
        { code: MEDIAN, name: i18n.median },
        { code: MIN, name: i18n.min },
        { code: MAX, name: i18n.max },
    ]

    const groupOptions = [
        { code: AVERAGE, name: i18n.average },
        { code: MIN, name: i18n.min },
        { code: MAX, name: i18n.max },
    ]

    return (
        <StepperDialog
            steps={[
                {
                    label: i18n.stations,
                    constant: STEP.STATIONS,
                },
                {
                    label: i18n.calcul,
                    constant: STEP.CALCULATE,
                },
            ]}
            open={paramsDialogIsOpen}
            title={i18n.calculationParams}
            sx={{ minHeight: 0 }}
            closeDialog={() => changeState({ paramsDialogIsOpen: false })}
            renderSaveButton={(step, resetStep) => (step === STEP.CALCULATE) && (
                <Grid container justifyContent='space-between'>
                    <Grid size={6}>
                        <ButtonMUI
                            onClick={() => {
                                resetStep()
                                onSave()
                            }}
                            variant='contained'
                            color='primary'
                        >
                            {i18n.save}
                        </ButtonMUI>
                    </Grid>
                    <Grid size={6}>
                        <ButtonMUI
                            onClick={() => {
                                resetStep()
                                onSave(true)
                            }}
                            variant='contained'
                            color='primary'
                        >
                            {i18n.saveAndCalculate}
                        </ButtonMUI>
                    </Grid>
                </Grid>
            )}
        >
            {(step) => {
                switch (step) {
                    case STEP.STATIONS:
                        const selectedStations = stations.filter(p => params.stationIds.includes(p.id))
                        return (
                            <Grid container spacing={1}>
                                <Grid size={6}>
                                    <RadioButtons
                                        elements={ [{ value: true, label: i18n.allStations }, { value: false, label: i18n.chooseStations }] }
                                        selected={ hasBooleanValue(params.allStations) ? params.allStations : false }
                                        onChange={ v => changeParams({ allStations: v }) }
                                        title={ '' }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    {!(hasBooleanValue(params.allStations) ? params.allStations : false) && (
                                        <SelectStationComponent
                                            selectedStations={selectedStations}
                                            campaignEvents={[]}
                                            stationType={st}
                                            onChangeSelectedStation={tmpStations => changeParams({ stationIds: tmpStations.map(p => p.id) })}
                                            networkLinks={state.networkLinks}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        )
                    case STEP.CALCULATE:
                        const calculType = msSelected.calculType || 'now'
                        return (
                            <div>
                                <StyledFieldSet>
                                    <StyledLegend>{i18n.calcul}</StyledLegend>
                                    <Grid container sx={{ padding: '1rem' }} spacing={1}>
                                        <Grid container size={12} spacing={2}>
                                            <Grid size={6}>
                                                <Input
                                                    title={i18n.name}
                                                    onChange={v => change({ name: v })}
                                                    value={msSelected.name}
                                                />
                                            </Grid>
                                            <Grid size={6}>
                                                <MultiContributorsAutocomplete
                                                    label={i18n.administrator}
                                                    disablePortal={false}
                                                    options={contributors}
                                                    values={msSelected.contributorCode}
                                                    onChange={contributorCode => change({ contributorCode })}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12} spacing={2}>
                                            <Grid size={5}>
                                                <SuperMultiAutocomplete
                                                    label={i18n.chronicType}
                                                    options={orderBy(dataTypes, 'id')}
                                                    values={msSelected.typeId}
                                                    onChange={v => change({ typeId: v })}
                                                    noSort
                                                />
                                            </Grid>
                                            {isPluviometry && (
                                                <Grid size={4}>
                                                    <NumberField
                                                        title={i18n.cumulHours}
                                                        value={params.nbHoursCumul || 24}
                                                        onChange={v => changeParams({ nbHoursCumul: v })}
                                                        min={1}
                                                    />
                                                </Grid>
                                            )}
                                            <Grid size={isPluviometry ? 3 : 7}>
                                                <Select
                                                    label={i18n.calculType}
                                                    options={getCalculTypeOptions()}
                                                    keyValue='code'
                                                    keyLabel='name'
                                                    value={calculType}
                                                    onChange={v => change({ calculType: v, scheduled: v === 'daily' })}
                                                    noNullValue
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12} spacing={2}>
                                            {calculType === 'date' && (
                                                <Grid size={5}>
                                                    <SimpleDatePicker
                                                        label={i18n.date}
                                                        value={msSelected.startPeriod}
                                                        onChange={date => change({ startPeriod: date })}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid container size={12} spacing={2}>
                                            {calculType === 'period' && (
                                                <>
                                                    <Grid container size={5} spacing={2}>
                                                        <Grid size={6}>
                                                            <SimpleDatePicker
                                                                label={i18n.startDate}
                                                                value={msSelected.startPeriod}
                                                                onChange={date => change({ startPeriod: date })}
                                                                max={msSelected.endPeriod}
                                                                disabled={calculType !== 'period'}
                                                            />
                                                        </Grid>
                                                        <Grid size={6}>
                                                            <SimpleDatePicker
                                                                label={i18n.endDate}
                                                                value={msSelected.endPeriod}
                                                                onChange={date => change({ endPeriod: date })}
                                                                min={msSelected.startPeriod}
                                                                disabled={calculType !== 'period'}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid size={7}>
                                                        <RadioButtons
                                                            elements={[
                                                                { code: 'day', name: i18n.day },
                                                                { code: 'week', name: i18n.week },
                                                                { code: 'month', name: i18n.month },
                                                            ]}
                                                            selected={msSelected.recurrence}
                                                            onChange={v => change({ recurrence: v })}
                                                            title={i18n.recurrence}
                                                            disabled={calculType !== 'period'}
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                         <Grid container size={12} spacing={2}>
                                             <Grid size={6}>
                                                 <Select
                                                     label={i18n.benchmarkIndicator}
                                                     options={refList}
                                                     keyValue='code'
                                                     keyLabel='name'
                                                     value={params.refUsed}
                                                     onChange={v => changeParams({ refUsed: v })}
                                                     noNullValue
                                                 />
                                             </Grid>
                                         </Grid>
                                        <Grid container size={12} spacing={2}>
                                            <Grid size={6}>
                                                <Select
                                                    label={i18n.dailyRegroup}
                                                    options={groupOptions}
                                                    keyValue='code'
                                                    keyLabel='name'
                                                    value={params.customCalculDailyGroup}
                                                    disabled={params.refUsed !== OTHER}
                                                    onChange={v => changeParams({ customCalculDailyGroup: v })}
                                                />
                                            </Grid>
                                            <Grid size={6}>
                                                <NumberField
                                                    title={i18n.nbOfDaysCalculation}
                                                    value={params.customCalculNbDays}
                                                    disabled={params.refUsed !== OTHER}
                                                    min={0}
                                                    onChange={v => changeParams({ customCalculNbDays: v })}
                                                />
                                            </Grid>
                                            <Grid size={6}>
                                                <Select
                                                    label={i18n.calculationMethod}
                                                    options={calculMethodOptions}
                                                    keyValue='code'
                                                    keyLabel='name'
                                                    value={params.customCalculMethod}
                                                    disabled={params.refUsed !== OTHER}
                                                    onChange={v => changeParams({ customCalculMethod: v })}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </StyledFieldSet>
                                <StyledFieldSet>
                                    <StyledLegend>{i18n.advancedOptions}</StyledLegend>
                                    <Grid container sx={{ padding: '1rem' }} spacing={1}>
                                        <Grid container size={12} spacing={2}>
                                            <Grid size={5}>
                                                <RadioButtons
                                                    elements={[
                                                        { code: true, name: i18n.yes },
                                                        { code: false, name: i18n.no },
                                                    ]}
                                                    selected={params.validOnly}
                                                    onChange={v => changeParams({ validOnly: v })}
                                                    title={i18n.calcValidDataOnly}
                                                />
                                            </Grid>
                                            <Grid size={4}>
                                                <Checkbox
                                                    checked={msSelected.usePredict}
                                                    label={i18n.usePredictData}
                                                    onChange={v => change({ usePredict: v })}
                                                />
                                            </Grid>
                                            <Grid size={3}>
                                                <Checkbox
                                                    checked={msSelected.exportCSV}
                                                    label={i18n.exportToCSV}
                                                    onChange={v => change({ exportCSV: v })}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12} spacing={2}>
                                            <Grid size={6}>
                                                <NumberField
                                                    title={i18n.numberOfYearsHistoryRequired}
                                                    value={params.nbYearsHistoRequired}
                                                    onChange={v => changeParams({ nbYearsHistoRequired: v })}
                                                    min={ 1 }
                                                />
                                            </Grid>
                                            <Grid size={6}>
                                                <NumberField
                                                    title={ i18n.nbDaysForTrend }
                                                    value={ params.nbDaysForTrendCalculation }
                                                    onChange={ v => changeParams({ nbDaysForTrendCalculation: v }) }
                                                    min={ 1 }
                                                />
                                            </Grid>
                                            <Grid size={6}>
                                                <NumberField
                                                    title={i18n.nbDaysWithoutAcceptableData}
                                                    value={params.nbDaysWithoutMeasuresMax}
                                                    onChange={v => changeParams({ nbDaysWithoutMeasuresMax: v })}
                                                    min={1}
                                                />
                                            </Grid>
                                            <Grid size={6}>
                                                <NumberField
                                                    title={ i18n.fluctuationPercentage }
                                                    value={ (params.fluctuationPercentage || 0) * 100 }
                                                    onChange={ v => changeParams({ fluctuationPercentage: v ? v*0.01 : v }) }
                                                    min={ 0 }
                                                    max={100}
                                                    floatValue
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </StyledFieldSet>
                            </div>
                        )
                    default:
                        return null
                }
            }}
        </StepperDialog>
    )
}

export { getThresholdIndicatorDialog, getThresholdIndicatorDefaultParams, getThresholdIndicatorLegend, getThresholdIndicatorPie }